import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
import { Seguimiento_certificadoComponent } from '../seguimiento_certificado/seguimiento_certificado.component';
import { HomeComponent } from '../home/home.component';


declare const swal: any;
@Component({
  selector: "page-auxUrlcert",
  templateUrl: "auxUrlcert.component.html",
  styleUrls: ["./auxUrlcert.component.css"]
})

export class AuxUrlcertComponent {
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
  constructor(private dialog: MatDialog, private _router: Router, private _snackBar: MatSnackBar) {

  }

  sign(tipo) {
    this.dialog.open(HomeComponent, {
      data: {
        url: tipo
      }
    })

    if (sessionStorage.getItem("identity-domCloud") && sessionStorage.getItem("token-domCloud")) {
      this.dialog.closeAll();
      if (tipo == 'seg-certificados') {
        this._router.navigate([`/seguimiento_certificados`]);
      }
      if (tipo == 'val-certificado') {
        this._router.navigate([`/validar-certificado`]);
      }
    } else {
      if (tipo == 'seg-certificados') {
        this._router.navigate([`/seguimiento_certificados`]);
      }
      if (tipo == 'val-certificado') {
        this._router.navigate([`/validar-certificado`]);
      }
    }
    this.dialog.closeAll()
  }

  solicitud_certificado(){
    console.log("solicitud_certificado()")
    this._router.navigate([`/certificados`]);
  }

  seguimiento() {
    this.dialog.open(Seguimiento_certificadoComponent);
  }

  fireDialog() {
    swal({
      type: 'warning',
      title: 'Atención!',
      text: `<p style:"color: red;font-weight: 900;font-size: 27px;">Sitio en Mantención.</p>
            <p style:"color: black;font-size: 19px;font-weight: 600;">Consultas llamar al fono 224327736.</p>`,
      confirmButtonColor: '#3F51B5',
      confirmButtonText: 'Aceptar',
      onClose: () => {
        this.dialog.closeAll()
      }
    }).then(() => {
    }, (dismiss) => {
      if (dismiss === 'timer') {
        this.dialog.closeAll()
      }
    });
  }
}
